import Seo from "../components/Seo";
import NonAffiliationBanner from "../components/NonAffiliationBanner";

export default function Safety() {
  return (
    <>
      <Seo
        title="Safety & Code of Conduct"
        description="Safety expectations and code of conduct for HS Library Hangout board game gatherings."
      />
      <h1>Safety &amp; Code of Conduct</h1>
      <NonAffiliationBanner compact />

      <section className="card">
        <h2>Parent presence is required</h2>
        <p>
          An adult parent organizer will be present for the duration of every gathering. The organizer is
          a volunteer parent, not a library employee or a childcare professional.
        </p>
        <p>
          <strong>Eligible grades:</strong> 8th grade through 12th grade (ages 13-18). Younger
          siblings are not able to attend gatherings.
        </p>
      </section>

      <section className="card">
        <h2>Arrival &amp; pickup</h2>
        <p>
          Please arrive 5-10 minutes before the start time so we can get everyone checked in and settled
          before games begin.
        </p>
        <p>
          If a parent will be late, text the organizer immediately using the number provided in your
          confirmation email so we know your teen&rsquo;s ride is on the way.
        </p>
      </section>

      <section className="card">
        <h2>Code of conduct</h2>
        <ul>
          <li>Treat all participants, library staff, and patrons with respect and kindness.</li>
          <li>No bullying, harassment, threats, fighting, or inappropriate language.</li>
          <li>Respect personal boundaries and personal property.</li>
          <li>Keep games and conversation age-appropriate.</li>
          <li>Follow organizer directions and all library rules.</li>
          <li>Maintain reasonable noise levels appropriate for a library setting.</li>
          <li>Serious or repeated violations may result in immediate parent contact and removal.</li>
        </ul>
      </section>

      <section className="card">
        <h2>What this group is not</h2>
        <p>HS Library Hangout is not, and should not be relied upon as:</p>
        <ul>
          <li>Childcare</li>
          <li>Professional supervision</li>
          <li>Therapy</li>
          <li>A school program</li>
          <li>A library program</li>
        </ul>
      </section>
    </>
  );
}
